var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"web"}},[_c('div',{staticClass:"left"},[_c('side-menu')],1),_c('div',{staticClass:"right"},[_c('div',{staticClass:"top"},[_c('home-header')],1),_c('div',{staticClass:"rest"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }